import React from 'react';
import styles from './Submenu.module.scss';
import { GreyBoxLoader } from '@xarvio/elements';
import cx from 'classnames';

export interface SubmenuItemLoadingProps {
  className?: string;
  width?: string;
}

const SubmenuItemLoading: React.FC<
  React.PropsWithChildren<SubmenuItemLoadingProps>
> = ({ className, width }) => {
  return (
    <div className={cx(styles.itemLoading, className)} style={{ width }}>
      <div className={styles.itemLoadingIcon}>
        <GreyBoxLoader />
      </div>
      <div className={styles.itemLoadingLabel}>
        <GreyBoxLoader />
      </div>
    </div>
  );
};

export { SubmenuItemLoading };
